import { RootState } from "../types/store.types";

export const selectClientSettings = (state: RootState) => state.clientSettings?.settings;
export const selectAccountBookSettings = (state: RootState) => state.clientSettings?.settings?.accountingBookSettings;
export const selectDataSetSettings = (state: RootState) => state.clientSettings?.settings?.dataSets ?? [];
export const selectClientSettingsLoaded = (state: RootState) => state.clientSettings?.loaded;
export const selectClientSettingsLoadingFailed = (state: RootState) => state.clientSettings?.loadingFailed;
